import { render, staticRenderFns } from "./DeliveryZoneMaster.vue?vue&type=template&id=ebf626be&scoped=true&"
import script from "./DeliveryZoneMaster.vue?vue&type=script&lang=ts&"
export * from "./DeliveryZoneMaster.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryZoneMaster.vue?vue&type=style&index=0&id=ebf626be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf626be",
  null
  
)

export default component.exports